import {useEffect, useState} from "react";
import {Spinner} from "react-bootstrap";
import PaginationComponent from "../../component/global/PaginationComponent";
import {get} from "../../controlers/global/ConfigRequest";
import {GET_MARKET_ITEMS} from "../../helperData/ApiAddress";
import ItemCart from "./components/ItemCart";
import {useTranslation} from "react-i18next";

export default function MyItems() {
  const [items, setItems] = useState(undefined);
  const [page, setPage] = useState("1");
  const {t} = useTranslation()

  useEffect(() => {
    var url = new URL(GET_MARKET_ITEMS);
    url.searchParams.set("brand", window.sessionStorage.getItem('usercompany'));
    url.searchParams.set("page", page);

    get(url).then(r => {
      setItems(r);
    })
  }, [page]);

  return (
    <div className="my-items-section items-section">
      <div className="cart-grid">
        {
          items
            ?
            items.results.length > 0
              ?
              items.results.map(item => (
                <ItemCart
                  link={item.id}
                  score={item.computed_score}
                  description={item.description}
                  name={item.name}
                  photo={item.photo}
                  priceMin={item.price_min}
                  priceMax={item.price_max}
                  salersCount={item.salers_count}
                />
              ))
              :
              <span className="empty-item">{t('Src.Pages.Food.Not.Found')}</span>
            :
            <Spinner animation="border"/>

        }
      </div>
      {
        items?.count > 20 &&
        <PaginationComponent
          currentPage={page - 1}
          pageCount={Math.ceil(items.count / 20)}
          fetchData={e => setPage(e.pageIndex + 1)}
          feedbacks={items.results}
        />
      }
    </div>
  )
}
